module.exports = __webpack_public_path__ + "static/media/crown2.cc791546.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/crown2.png
// module id = 1966
// module chunks = 6